import { Router } from './Router.ts';
import { routerManager } from './routerManager.ts';

/** Set the current Router */
export function setRouter(router: Router) {
  routerManager.router = router;
}